"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetSorting = exports.setSorting = exports.RESET_SORTING = exports.SET_SORTING = exports.SORTING = void 0;
exports.SORTING = '[Sorting]';
exports.SET_SORTING = `${exports.SORTING} SET`;
exports.RESET_SORTING = `${exports.SORTING} RESET`;
const setSorting = ({ sorting }) => ({
    type: exports.SET_SORTING,
    payload: sorting,
    meta: { feature: exports.SORTING },
});
exports.setSorting = setSorting;
const resetSorting = () => ({
    type: exports.RESET_SORTING,
    payload: {},
    meta: { feature: exports.SORTING },
});
exports.resetSorting = resetSorting;
//# sourceMappingURL=sorting.js.map